import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import * as moment from "moment";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { PlyrComponent } from "ngx-plyr";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-my-department-classes",
  templateUrl: "./my-department-classes.component.html",
  styleUrls: ["./my-department-classes.component.css"],
})
export class MyDepartmentClassesComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  @ViewChild(PlyrComponent) plyr: PlyrComponent;
  page: number = 1;
  page_size: number = 10;
  StudentvideoList: any;
  Studentvideo: any;
  Studentvideo1 = [];
  Table_pagination: boolean;
  prolength: any;
  department: Object;
  dept: any;
  classroom: Object;
  class: any;
  subject: Object;
  subjectData: any;
  department_id: any;
  subject_id: any;
  classroom_id: any;
  htmlpageshow: boolean;
  page_count = [];
  total_count = 0;
  pagedItems: any[];
  total: number;
  p: number;
  showLoadMore = false;
  submitted = false;
  pageshow = true;
  filter: any;
  stufilter: boolean = true;
  filter_from: any;
  filter_end: any;
  batch: Object;
  batchData: any;
  batch_id: any;
  prodessor: Object;
  prodessorData: any;
  professor_id: any;
  videodec: any;
  showvideo = false;
  viewvideo = false;
  videosrc: any;
  dataindex: any;
  filter_date: any = [];
  searchForm: any;
  player: Plyr;
  isLoginType: boolean;
  departmentid: any;
  userid: any;
  batchid: any;
  professorid: any;
  profid: boolean = false;
  subjectlist: boolean;
  filtervalues: boolean;
  chiparray: any = [];
  is_student_search_all_video: string = "";
  hod: any;
  isImpersonate: any = "";
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    public commonService: CommonService
  ) {}

  roleId = this.storageService.getRole();
  async ngOnInit() {
    this.hod = this.storageService.getHod();
    this.is_student_search_all_video = this.ls.get(
      "is_student_search_all_video"
    );
    this.subjectlist = false;
    this.route.queryParams.subscribe((params) => {
      this.isImpersonate = params["loginType"];
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        (this.roleId = this.ls.get("impersonate_role")),
          (this.department_id = this.ls.get("impersonate_department_id")),
          (this.batch_id = this.ls.get("impersonate_batch_id"));
      } else {
        this.roleId = this.storageService.getRole();
      }
    });

    this.searchForm = this.fb.group({
      date: [""],
      depname: [""],
      subjectname: [""],
      proname: [""],
      departmentname: [""],
      batchname: [""],
      classname: [""],
    });
    this.getDepartment();
    this.getSubject();
    this.getclassroom();
    this.getBatch();
    this.getProfessor();
    await this.getStudentvideoList();
  }

  get forms1() {
    return this.searchForm.controls;
  }
  async getPage(page: number) {
    this.page = page;
    this.getStudentvideoList();
    const res = await this.serverCall(this.Studentvideo, page);
    // this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  Filter(department_id, subject_id, classroom_id, batch_id, professor_id) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.filter != undefined && this.filter != "") {
      this.chiparray.push(
        "Date :" + " " + this.filter_from + " - " + this.filter_end
      );
    }

    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.prodessorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
          " " +
          proffessor[0].first_name +
          " " +
          proffessor[0].last_name
      );
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      if (dept.length) {
        this.chiparray.push("Dept:" + " " + dept[0].name);
      }
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }
    if (this.batch_id != undefined && this.batch_id != "") {
      var Batch = this.batchData.filter((x) => x.id == this.batch_id);
      if (Batch.length) {
        this.chiparray.push("Batch:" + " " + Batch[0].batch);
      }
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      if (classroom.length) {
        this.chiparray.push("Class:" + " " + classroom[0].name);
      }
    }
    this.department_id = department_id;
    this.subject_id = subject_id;
    this.classroom_id = classroom_id;
    this.batch_id = batch_id;
    this.professor_id = professor_id;
    this.pageshow = true;
    this.page = 1;
    this.getStudentvideoList();
  }

  async getProfessor() {
    this.Studentvideo = [];
    this.spinner.show();
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.prodessor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.prodessorData = this.prodessor["content"];
    this.spinner.hide();
  }

  getStudentvideoList() {
    this.Studentvideo = [];
    this.spinner.show();
    this.subjectlist = false;
    let filter = {};
    if (this.isImpersonate == "impersonate") {
      this.roleId = this.ls.get("impersonate_role");
      this.departmentid = this.ls.get("impersonate_department_id");
      this.batchid = this.ls.get("impersonate_batch_id");
    } else {
      this.roleId = this.storageService.getRole();
      if (this.roleId == 4) {
        this.professorid = this.ls.get("createdBy");
      } else {
        this.departmentid = this.storageService.getDepartment();
        this.batchid = this.ls.get("batch_id");
      }
    }
    this.batch_id = this.batchid;
    this.department_id = this.departmentid;
    if (this.roleId === 5) {
      this.searchForm.controls.departmentname.disable();
    }
    if (this.roleId === 5) {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        department_id: this.departmentid,
        subject_id: this.subject_id,
        batch_id: this.batchid,
        professor_id: this.professor_id,
        camera_start: this.filter_from,
        camera_end: this.filter_end,
      };
      this.globalService
        .get("classVideoDetail/get-today-schedule", filter)
        .then((data) => {
          this.StudentvideoList = data;
          this.Studentvideo = this.StudentvideoList["content"]["rows"];
          this.total = this.StudentvideoList["content"]["count"];
          this.spinner.hide();
        });
    }
  }

  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }

  videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    let key = id;
    if (this.isImpersonate === "impersonate") {
      window.open(
        `/video/play?key=${key}&loginType=impersonate&isHls=${encrypt(
          enryptText
        )}`,
        "_blank"
      );
    } else {
      window.open(
        `/video/play?key=${key}&isHls=${encrypt(enryptText)}`,
        "_blank"
      );
    }
  }

  async getBatch() {
    this.Studentvideo = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get("batch/list/dropdown", filter);

    this.batchData = this.batch["content"];
    if (this.roleId === 5) {
      this.searchForm.controls.batchname.setValue(this.batchid);
      this.searchForm.controls.batchname.disable();
    }
    this.spinner.hide();
  }
  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;

      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 30) {
        this.filter_date = "";
        Swal.fire({
          text: "Please select dates within 30 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
      }
    }
  }
  async getclassroom() {
    this.Studentvideo = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSubject() {
    this.Studentvideo = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    if (this.pageshow === true) {
      this.page_count = [];
      let page_count = Math.ceil(this.total_count / this.page_size);
      if (page_count > 1) {
        this.htmlpageshow = true;
      } else {
        this.htmlpageshow = false;
      }
    }
  }
  increaseShow() {
    // this.page += 1;
    this.getStudentvideoList();
  }

  reset() {
    this.submitted = false;
    this.searchForm.reset();
  }

  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getStudentvideoList();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getStudentvideoList();
  }

  res() {
    this.filtervalues = false;
    if (this.storageService.getRole() != 4 && this.hod != 1) {
      this.department_id = null;
      this.batch_id = null;
    }
    this.subject_id = null;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.professor_id = null;
    this.filter_date = null;
    this.searchForm.reset();
    this.showvideo = false;
    this.viewvideo = false;
    this.getStudentvideoList();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getStudentvideoList();
  }
}
